import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSession } from '@/lib/SessionContext';
import { base44 } from '@/api/base44Client';
import { toast } from 'sonner';

const BirthdayContext = createContext();

export function useBirthday() {
  return useContext(BirthdayContext);
}

export function BirthdayProvider({ children }) {
  const { member } = useSession();
  const [simulatedDate, setSimulatedDate] = useState(null);
  const [simulatedBirthdayUserId, setSimulatedBirthdayUserId] = useState(null);
  
  const [teamMembers, setTeamMembers] = useState([]);
  const [birthdayMessages, setBirthdayMessages] = useState([]);

  useEffect(() => {
    // Load team members to find birthdays
    base44.entities.TeamMember.list().then(setTeamMembers);
    
    // Attempt to load mock birthday messages from localStorage
    const savedMessages = localStorage.getItem('mock_BirthdayMessages');
    if (savedMessages) {
      try {
        setBirthdayMessages(JSON.parse(savedMessages));
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  // Save messages to local storage whenever they change
  useEffect(() => {
    localStorage.setItem('mock_BirthdayMessages', JSON.stringify(birthdayMessages));
  }, [birthdayMessages]);

  const today = simulatedDate ? new Date(simulatedDate) : new Date();
  const todayMonth = today.getMonth() + 1;
  const todayDay = today.getDate();

  // Find users who have a birthday today
  const birthdayUsers = teamMembers.filter(m => {
    if (simulatedBirthdayUserId && m.id === simulatedBirthdayUserId) return true;
    if (!m.birth_date) return false;
    const bDate = new Date(m.birth_date);
    return (bDate.getMonth() + 1) === todayMonth && bDate.getDate() === todayDay;
  });

  const isMyBirthday = member && birthdayUsers.some(u => u.id === member.id);
  
  // Exclude myself from colleagues having birthdays
  const colleaguesWithBirthday = member ? birthdayUsers.filter(u => u.id !== member.id) : [];

  const sendBirthdayMessage = (targetUserId, messageText) => {
    if (!member) return;
    const newMessage = {
      id: 'bm_' + Date.now(),
      target_user_id: targetUserId,
      sender_id: member.id,
      sender_name: member.full_name,
      sender_photo: member.photo_url || null,
      message: messageText,
      created_at: new Date().toISOString(),
      read: false
    };
    setBirthdayMessages(prev => [...prev, newMessage]);
    toast.success('Pesan ucapan ulang tahun berhasil dikirim! 🎉');
  };

  const markMessagesAsRead = (targetUserId) => {
    setBirthdayMessages(prev => prev.map(m => {
      if (m.target_user_id === targetUserId && !m.read) {
        return { ...m, read: true };
      }
      return m;
    }));
  };

  const myMessages = member ? birthdayMessages.filter(m => m.target_user_id === member.id) : [];
  const unreadCount = myMessages.filter(m => !m.read).length;

  return (
    <BirthdayContext.Provider value={{
      simulatedDate, setSimulatedDate,
      simulatedBirthdayUserId, setSimulatedBirthdayUserId,
      isMyBirthday,
      colleaguesWithBirthday,
      sendBirthdayMessage,
      myMessages,
      unreadCount,
      markMessagesAsRead
    }}>
      {children}
    </BirthdayContext.Provider>
  );
}
